import { AdminHeader } from 'components/admin/header/AdminHeader';
import { GuideLandingGuest } from 'components/admin/landing/GuideLandingGuest';
import { GuideLandingLogged } from 'components/admin/landing/GuideLandingLogged';
import { LanguageSwitch } from 'components/guide/other/LanguageSwitch';
import { Page } from 'elements/admin/layout/Page';
import { ReverseButton } from 'elements/eventView/atomic/ReverseButton';
import { EColors2, EFonts } from 'libs/styles/styling';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { GlobalContext } from 'session/state/context';
import styled from 'styled-components/macro';

export const GuideLandingPage = (): JSX.Element => {
    const { state } = useContext(GlobalContext);
    const location = useLocation();
    const isWide = useIsWide();
    const [mobileMessage, setMobileMessage] = useState(true);

    useEffect(() => {
        if (location.state && location.state.from) {
            window.scrollTo(0, location.state.from.scrollY);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    if (!state.loggedUserChecked) {
        return null;
    }

    return (
        <S_GuideLandingPage>
            {!isWide && mobileMessage && (
                <S_MobileMessage>
                    Our builder is not yet available for mobile phones. Please use a computer to
                    create your guides or interactive maps. Naturally, all the things you create
                    will work perfectly on mobile phones for your visitors
                    <S_ReverseButton
                        text="Continue anyway"
                        onClick={() => {
                            setMobileMessage(false);
                        }}
                        iconName="arrow-right"
                    />
                    <S_ReverseButton
                        text="Go to our homepage"
                        onClick={() => {
                            window.location.href = 'https://mapheim.com';
                        }}
                        iconName="arrow-up-right-from-square"
                    />
                </S_MobileMessage>
            )}
            <AdminHeader />
            {state.loggedUser ? <GuideLandingLogged /> : <GuideLandingGuest />}
            <S_LanguageSwitch />
        </S_GuideLandingPage>
    );
};

const S_GuideLandingPage = styled(Page)``;

const S_MobileMessage = styled.div`
    background-color: ${EColors2.DARK};
    color: white;
    padding: 30px 20px;
    font-size: 15px;
    line-height: 25px;
    font-family: ${EFonts.InterRegular};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
`;

const S_ReverseButton = styled(ReverseButton)`
    margin-top: 30px;
`;

const S_LanguageSwitch = styled(LanguageSwitch)`
    margin: 0 0 50px 0;
`;
